/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Send: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.9351 4.57536C18.4607 4.11768 19.8831 5.5401 19.4254 7.06571L15.9819 18.5441C15.4378 20.3576 12.9125 20.4702 12.2093 18.7122L10.2319 13.7688L5.28855 11.7915C3.53063 11.0883 3.64315 8.56294 5.45664 8.01889L16.9351 4.57536ZM12.1746 13.2404L14.0662 17.9694L17.5098 6.49101L6.03133 9.93454L10.7604 11.8262L11.8941 10.6924C12.2847 10.3019 12.9178 10.3019 13.3083 10.6924C13.6989 11.083 13.6989 11.7161 13.3083 12.1066L12.1746 13.2404Z'
      fill='currentColor'
    />
  </React.Fragment>
)
